import { TranslateService } from '@ngx-translate/core';
import { RulesService } from 'app/services/audit/rules.service';
import { MessageService, SelectItem } from 'primeng/primeng';
import { PhaseToolbarModel } from '../../../campaign-3/models/phases-toolbar.model';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BreadCrumbModel } from '../../../campaign-3//models/campaign-3-breadcrumb.model';
import { AuditInfoBaseComponent } from './audit-rule-base/audit-rule-base.component';
import { AuditConditionComponent } from './audit-condition/audit-condition.component';
import { Campaign3BreadcrumbComponent } from '../../../campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';
import { AuditRuleObject, AuditRulesType, AuditTemplate, AuditTemplateAssignment, JsonSchema } from 'app/views/audit/models/audit-event.model';
import { CustomerClusterService } from 'app/services/customer/customer-cluster.service';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';
import { LoyaltyCardService } from 'app/services/loyalty/loyalty-card.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Moment } from 'moment';
import * as moment from 'moment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Acm } from 'app/models/loyalty-acm.model';
import { AuditNewActionComponent } from './audit-action/audit-new-action/audit-new-action.component';
import { AuditActionComponent } from './audit-action/audit-action.component';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { tap } from 'rxjs/operators/tap';
import { AcmTypeHasReasonService } from 'app/services/loyalty/acm-type-has-reason.service';
import { AcmTypehasReason } from 'app/models/loyalty-acm-type.model';
import { PromotionOchannelService } from 'app/services/promotion/promotion-ochannel.service';
import { SourceSystemService } from 'app/services/source-system/source-system.service';
import { ChallengeService } from 'app/views/challenge/challenge.service';
import { ChallengeResponse } from 'app/views/challenge/challenge.model';

@Component({
  selector: 'app-add-rule',
  templateUrl: './add-rule.component.html',
  styleUrls: ['./add-rule.component.css']
})
export class AddRuleComponent implements OnInit {
  //COMPONENTE BREADCRUMB
  @ViewChild('breadcrumbComponent') breadcrumbComponent: Campaign3BreadcrumbComponent;

  //COMPONENTI DELLE VARIE FASI:
  @ViewChild('infoBaseComponent') infoBaseComponent: AuditInfoBaseComponent; //FASE 1
  @ViewChild('conditionComponent') conditionComponent: AuditConditionComponent; //FASE 2
  @ViewChild('actionComponent') actionComponent: AuditActionComponent; //FASE 3
  @ViewChild('actionNewComponent') actionNewComponent: AuditNewActionComponent; //FASE 2
  @ViewChild('actionListTable') actionListTable: Campaign3KontableComponent;
  dateRangeForm: FormGroup;
  actionsRulesType: Array<AuditRulesType>;
  actionsRulesTypeCombo: SelectItem[];
  ruleId: number;
  clusters = [];
  listReasons: SelectItem[] = [];
  clusterOption: SelectItem[] = [];
  clusterOptionActive: SelectItem[] = [];
  touchpointOption: SelectItem[] = [];
  sourceSystemOption: SelectItem[] = [];
  acmList: SelectItem[] = [];
  sourceSystemList: SelectItem[] = [];
  channelConditionList: SelectItem[] = [];
  acmForReasonList: SelectItem[] = [];
  acmListFull: Array<Acm> = [];
  challengeList: SelectItem[] = [];
  challengeListFull: Array<ChallengeResponse> = [];
  dateFormat: string = 'dd/MM/yyyy';
  schemaMode: string = this.rulesService.schema_modes.CREATE;
  uiModes = {
    infoBase: this.rulesService.ui_modes.CREATE,
    condition: this.rulesService.ui_modes.CREATE,
    actions: this.rulesService.ui_modes.CREATE
  };
  auditRuleObject: AuditRuleObject = null;
  realodDataValidation: boolean = false;
  listSchemas: Array<AuditTemplateAssignment> = [];
  listTemplates: Array<AuditTemplate> = [];
  readOnly: boolean = false;
  listReasonsFull: Array<AcmTypehasReason> = [];
  listReasonsFiltered: SelectItem[] = [];

  auditPhases: Array<PhaseToolbarModel> = [];
  phaseClick: PhaseToolbarModel
  //currentJsonSchemaMode = null;
  currentPhaseIndex: number = 0;

  globalFormsSchema: JsonSchema;
  phaseChanged: boolean = false;
  breadcrumbs: Array<BreadCrumbModel> = [];
  errorRetriveData: boolean = false;

  show = { globalFormsSchema: false, breadcrumbs: false, phases: false, infoBase: false, condition: false, action: false }

  enable = { confirmButton: false }

  get isChallenge(): boolean {
    const selectedTypeId = this.infoBaseComponent && this.infoBaseComponent.selectedRule;
    if (!selectedTypeId || !this.actionsRulesType) return false;
    const ruleType = this.actionsRulesType.find(t => t.id === selectedTypeId);
    return ruleType != null && ruleType.code === 'challenge';
  }

  translations: any;

  //salvare tra i preferiti

  showSuccessPopup: boolean = false;
  showSuccessDeletePopup: boolean = false;


  constructor(
    private cdRef: ChangeDetectorRef,
    private srvTranslate: TranslateService,
    public rulesService: RulesService,
    private router: Router,
    private cardService: LoyaltyCardService,
    private customerClusterService: CustomerClusterService,
    private loyaltyAcmService: LoyaltyAcmService,
    private srvMessage: MessageService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private acmTypeHasReasonService: AcmTypeHasReasonService,
    private promoService: PromotionOchannelService,
    private sourceSystemService: SourceSystemService,
    private challengeService: ChallengeService



  ) {
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  auditRuleInstanceObjectChange(auditRuleInstanceObject: any) {
    if (this.uiModes.infoBase == this.rulesService.ui_modes.EDIT) {
      var self = this;
      if (
        auditRuleInstanceObject.status = false
      ) {
        this.readOnly = true;
      }
      setTimeout(function () {
        if (self.actionComponent && self.conditionComponent) {
          var self2 = self;
        }
      }, 100);
    }
  }

  ngOnInit() {
    this.auditPhases = this.getAllPhases();
    this.ruleId = this.activatedRoute.snapshot.params['idRule'];
    this.uiModes.infoBase = this.activatedRoute.snapshot.params['infoBase'];
    this.listReasonsFiltered = [];
    const params = [{ key: 'limit', value: '9999999' }];
    params.push({ key: 'flg_state', value: '0' });
    const paramsOnlyClusterAll = [{ key: 'limit', value: '9999999' }];
    paramsOnlyClusterAll.push({ key: 'all_cluster', value: '0' });

    const acmReasonList$ = this.acmTypeHasReasonService.getFromAcmType(undefined, params).pipe(

      tap(resp => {
        // Controlla se ci sono dati nella risposta
        if (resp.data && resp.data.length > 0) {
          for (const reason of resp.data) {
            this.listReasonsFull.push(reason);
            this.listReasonsFiltered.push({
              value: reason.id,
              label: reason.reasonCode + " | " + reason.reasonDescription
            });
          }
        }
      })
    );

    const actionRulesType$ = this.rulesService.getActionRulesTypeList().pipe(
      tap(res => {
        this.actionsRulesTypeCombo = [];
        this.actionsRulesType = [];
        if (res) {
          res.forEach(typeRule => {
            this.actionsRulesTypeCombo.push({ label: `${typeRule.description}`, value: typeRule.id });
            this.actionsRulesType.push(typeRule);
          });
        }
      })
    );

    const reasonList$ = this.cardService.getReasonListWithParams(params).pipe(
      tap(res => {
        for (const reason of res.data) {
          this.listReasons.push({
            label: `${reason.reason_code} | ${reason.description}`,
            value: reason.id
          });
        }
        sessionStorage.setItem('ssReasons', JSON.stringify(this.listReasons));
      })
    );

    const clusterHeadAllList$ = this.customerClusterService.getClusterHeadAllListWithParams(paramsOnlyClusterAll).pipe(
      tap(res => {
        this.clusters = res;
        res.forEach((el) => {
          this.clusterOption.push({ label: `${el.clusterDescription} | ${el.date_start} - ${el.date_end} | ${el.code}`, value: `${el.clusterHeadId}`, date_end: el.date_end } as any);
        });
      })
    );

    const clusterHeadActiveList$ = this.customerClusterService.getClusterHeadAllListWithParams(params).pipe(
      tap(res => {
        this.clusters = res;
        res.forEach((el) => {
          this.clusterOptionActive.push({ label: `${el.clusterDescription} | ${el.date_start} - ${el.date_end} | ${el.code}`, value: `${el.clusterHeadId}`, date_end: el.date_end } as any);
        });
      })
    );
    const touchpointAllList$ = this.promoService.list(null, 9999999).pipe(
      tap(res => {
        if (Array.isArray(res)) {
          for (const channel of res) {
            this.touchpointOption.push({ label: `${channel.code} | ${channel.description}`, value: channel.id });
          }
        } else if (res && Array.isArray(res.data)) {
          for (const channel of res.data) {
            this.touchpointOption.push({ label: `${channel.code} | ${channel.description}`, value: channel.id });
          }
        }
      })
    );
    const sourcesystemAllList$ = this.sourceSystemService.getListWithParams(params).pipe(
      tap(res => {
        res.forEach(r => {
          this.sourceSystemOption.push({ label: `${r.description}`, value: r.id })
        });
      })
    );

    const acmFromParams$ = this.loyaltyAcmService.getAcmFromParams(params).pipe(
      tap(res => {
        res.forEach(acm => {
          this.acmList.push({ label: `${acm.acm_code} | ${acm.short_descr}`, value: acm.id });
          this.acmForReasonList.push({ label: `${acm.acm_code} | ${acm.short_descr}`, value: acm.id });
          this.acmListFull.push(acm);
        });
      })
    );

    /*const sourceSystemFromParams$ = this.customerDbService.getList().pipe(
      tap(res => {
        res.forEach(sourcesystem => {
          this.sourceSystemList.push({ label: `${sourcesystem.name}`, value: sourcesystem.id });
        });
      })
    );*/
    const jsonFormSchemaList$ = this.rulesService.getJsonFormSchemaList();
    const templateList$ = this.rulesService.getTemplateList();
    const challengeList$ = this.challengeService.list(null, 99999, null, null, null, null).pipe(
      tap(res => {
        if (res && res.data && res.data.length > 0) {
          res.data.forEach(challenge => {
            this.challengeList.push({ label: `${challenge.title} | ${challenge.description}`, value: challenge.id });
            this.challengeListFull.push(challenge);
          });
        }
      })
    );


    forkJoin([acmReasonList$, actionRulesType$, reasonList$, clusterHeadAllList$, clusterHeadActiveList$, touchpointAllList$, sourcesystemAllList$,
      acmFromParams$,/*sourceSystemFromParams$,*/ jsonFormSchemaList$, templateList$, challengeList$]).subscribe(
        ([, , , , , , ,/* ,*/, resSchema, resTemplates, resChallenge]) => {
          if (resSchema) {
            this.listSchemas = resSchema;
            if (resTemplates) {
              this.listTemplates = resTemplates;
              setTimeout(() => {
                this.initForm();
                this.initBreadCrumbs();
                this.initAll();
              }, 100);
            } else {
              this.srvMessage.add({
                severity: 'error',
                summary: this.srvTranslate.instant('common.error'),
                detail: this.srvTranslate.instant('audit.no_template_schema')
              });
            }
          } else {
            this.srvMessage.add({
              severity: 'error',
              summary: this.srvTranslate.instant('common.error'),
              detail: this.srvTranslate.instant('audit.no_template_schema')
            });
          }
        },
        error => console.error(error)
      );
  }
  initBreadCrumbs() {
    let bc1 = new BreadCrumbModel();
    bc1.code = "bc1";
    bc1.description = this.srvTranslate.instant('audit.manageEvents');
    this.breadcrumbs.push(bc1);
    let bc2 = new BreadCrumbModel();
    bc2.code = "bc2";
    bc2.description = this.srvTranslate.instant('audit.listRules');
    this.breadcrumbs.push(bc2);
    let bc3 = new BreadCrumbModel();
    bc3.code = "bc3";
    if (this.ruleId && this.ruleId > 0) {
      bc3.description = this.srvTranslate.instant('audit.modifyRule');
    } else {
      bc3.description = this.srvTranslate.instant('audit.addNewRule');
    }

    this.breadcrumbs.push(bc3);
  }
  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    this.router.navigate(['/rules-list'], {
      queryParams: { ruleId: this.ruleId }
    });
  }

  phaseClicked(phase: PhaseToolbarModel) {
    // In modalità EDIT (regola esistente), permetti sempre la navigazione tra le fasi
    // In modalità CREATE, blocca il click solo sulle fasi non accessibili (né done né firstUndone)
    const isEditMode = this.ruleId && this.ruleId > 0;
    const isPhaseAccessible = phase.done || phase.firstUndone || isEditMode;

    if (!isPhaseAccessible) {
      return; // Fase bloccata, non fare nulla
    }

    // Valida il form corrente prima di cambiare fase
    this.validaForms(false);

    // Naviga alla fase selezionata
    this.phaseClick = phase;
    this.goToPhase(phase.index);
  }

  onValidationEditClicked(phaseIndex: number) {
    let phase = this.auditPhases.find(x => x.index == phaseIndex)
    if (phase) {
      this.phaseClicked(phase);
    }
  }

  initAll() {
    this.setAuditRuleInstance();
  }
  getAllPhases(): Array<PhaseToolbarModel> {
    let res = null;
    let f1: PhaseToolbarModel = new PhaseToolbarModel();
    f1.index = 0;
    f1.code = "f1";
    f1.description = this.srvTranslate.instant('audit.rule');

    let f2: PhaseToolbarModel = new PhaseToolbarModel();
    f2.index = 1;
    f2.code = "f2";
    f2.description = this.srvTranslate.instant('audit.condition');

    let f3: PhaseToolbarModel = new PhaseToolbarModel();
    f3.index = 2;
    f3.code = "f3";
    f3.description = this.srvTranslate.instant('audit.action');

    res = [f1, f2, f3];
    return res;
  }

  onClickBackBtn() {
    //clicco su Indietro e diminuisco di uno la fase corrente, cioè torno alla fase precedente
    this.phaseClick = null; // Resetta il click sulla fase precedente per evitare comportamenti inconsistenti
    if (this.currentPhaseIndex > 0) {
      this.goToPhase(this.currentPhaseIndex - 1);
    }

  }

  hideAllForms() {
    this.show.infoBase = false;
    this.show.condition = false;
    this.show.action = false;
  }

  onClickSaveBtn() {
    this.validaForms(true);
  }

  goToNextPhase() {
    const nextPhaseIndex = this.currentPhaseIndex + 1;
    if (nextPhaseIndex <= this.auditPhases.length) {
      this.goToPhase(nextPhaseIndex);
    }
  }

  goToPhase(index: number) {
    // Nascondi tutti i form e attiva il form corrispondente alla nuova fase
    this.hideAllForms();

    // Aggiorna lo stato delle fasi prima di navigare
    this.processPhases(index, true);

    var self = this;
    setTimeout(function () {
      if (index >= 0 && index < self.auditPhases.length) {
        self.showFormForPhase(index);
      }
    }, 100);
  }

  showFormForPhase(index: number) {
    // Mostra il form corrispondente alla fase specificata
    switch (index) {
      case 0:
        this.show.infoBase = true;
        this.show.condition = false;
        this.show.action = false;

        break;
      case 1:
        this.show.action = false;
        this.show.infoBase = false;
        this.show.condition = true;
        break;
      case 2:
        this.show.condition = false;
        this.show.infoBase = false;
        this.show.action = true;

        break;
      default:
        console.error('Nessun componente per la Fase: ' + index);
        break;

    }

    // Aggiorna l'indicatore della fase corrente
    this.auditPhases[this.currentPhaseIndex].current = false;
    this.auditPhases[index].current = true;
    this.currentPhaseIndex = index;
  }

  onConfirmButtonEnabled(enabled: boolean) {
    this.enable.confirmButton = enabled;
  }

  setAuditRuleInstance() {
    this.globalFormsSchema = new JsonSchema();

    this.show.phases = true;
    this.show.globalFormsSchema = true;
    if (this.ruleId && this.ruleId > 0) {
      var self1 = this;
      setTimeout(function () {
        self1.schemaMode = self1.rulesService.schema_modes.EDIT;
        self1.rulesService.getAuditRuleGlobalObject(self1.ruleId).subscribe(res => {
          if (res) {
            self1.auditRuleObject = res;
            self1.breadcrumbComponent.campaignTypeName = self1.auditRuleObject.rule.code;
            self1.breadcrumbComponent.campaignTypeDescription = self1.auditRuleObject.rule.description;
            self1.uiModes.infoBase = self1.rulesService.ui_modes.EDIT;
            self1.uiModes.actions = self1.rulesService.ui_modes.EDIT;
            self1.uiModes.condition = self1.rulesService.ui_modes.EDIT;
            var self = self1;
            setTimeout(function () {
              self.processPhases(self.currentPhaseIndex, true); //perchè considero l'index
              self.goToPhase(self.currentPhaseIndex);
              self1.setFormField();
            }, 100);

          }
        });
      }, 200);
    } else {
      this.schemaMode = this.rulesService.schema_modes.CREATE;
      var self = this;
      setTimeout(function () {
        self.processPhases(self.currentPhaseIndex, true); //perchè considero l'index
        self.goToPhase(self.currentPhaseIndex); //-1 perchè considero l'index
      }, 100);

    }
  }
  setFormField() {
    this.infoBaseComponent.filteredChallengeList = (this.challengeList || []);
    const rawTypeId: any = this.auditRuleObject.rule.auditRulesTypeId;
    const resolvedTypeId = rawTypeId && rawTypeId.id ? rawTypeId.id : rawTypeId;
    this.infoBaseComponent.selectedRule = this.actionsRulesTypeCombo.find(f => f.value === resolvedTypeId);
    this.infoBaseComponent.loadJsonSchema(this.infoBaseComponent.selectedRule.value);

    this.infoBaseComponent.desc_rule.nativeElement.value = this.auditRuleObject.rule.description;
    this.infoBaseComponent.rule_code.nativeElement.value = this.auditRuleObject.rule.code;
    this.infoBaseComponent.fieldModel.rule_code = this.auditRuleObject.rule.code;
    this.infoBaseComponent.fieldModel.desc_rule = this.auditRuleObject.rule.description;
    this.dateRangeForm = this.fb.group({
      date_start: this.auditRuleObject.rule.dtDateStart
        ? [this.getDateFromStringToSTringCalendar(this.auditRuleObject.rule.dtDateStart), Validators.required] : ['', Validators.required],
      date_end: this.auditRuleObject.rule.dtDateEnd
        ? [this.getDateFromStringToSTringCalendar(this.auditRuleObject.rule.dtDateEnd), Validators.required] : ['', Validators.required],
    });
    //andrebbe fatto un controllo sull'esistenza della rule e rilanciato eventualemte un errore TODO
    if (this.auditRuleObject.rule.cluster) {
      this.infoBaseComponent.fieldModel.cluster = this.clusterOption.find(f => f.value == this.auditRuleObject.rule.clusterHeadId);
      //this.infoBaseComponent.fieldModel.cluster = this.auditRuleObject.rule.cluster_head_id;
    }
    if (this.auditRuleObject.rule.accumulatore) {
      this.infoBaseComponent.fieldModel.acm = this.acmList.find(f => f.value === this.auditRuleObject.rule.acmId);
      if (this.auditRuleObject.rule.flgRangeActive === null) {

      }
      else {
        if (this.auditRuleObject.rule.minRangeValue && this.auditRuleObject.rule.minRangeValue > 0) {
          this.infoBaseComponent.fieldModel.acm_min = this.auditRuleObject.rule.minRangeValue;
          this.infoBaseComponent.fieldModel.acm_max = this.auditRuleObject.rule.maxRangeValue;
          this.auditRuleObject.rule.flgRangeActive = '1'
          this.infoBaseComponent.fieldModel.acm_active_range = true;
        } else {
          this.infoBaseComponent.fieldModel.acm_min = null;
          this.infoBaseComponent.fieldModel.acm_max = null;
          this.auditRuleObject.rule.flgRangeActive = '0'
          this.infoBaseComponent.fieldModel.acm_active_range = false;
        }
      }
      //TODO da capire la logica
      //this.acmList = this.acmList.filter(item => item.value ===  this.auditRuleObject.rule.acm_id);
    }
    this.setSelectedChallengeOption();
    this.setSelectedDetailOption();
    if (this.auditRuleObject.rule.anagrafica) {
      this.infoBaseComponent.fieldModel.anag = this.auditRuleObject.rule.anagrafica;
      this.infoBaseComponent.fieldModel.cinfo_blacklist = this.auditRuleObject.rule.flgBlacklist == "1" ? true : false;
      this.infoBaseComponent.fieldModel.cinfo_newsletter = this.auditRuleObject.rule.flgNewsletter == "1" ? true : false;
      this.infoBaseComponent.fieldModel.cinfo_nominativo = this.auditRuleObject.rule.flgNominativo == "1" ? true : false;
      this.infoBaseComponent.fieldModel.cinfo_privacy = this.auditRuleObject.rule.flgPrivacy == "1" ? true : false;
      this.infoBaseComponent.fieldModel.cinfo_recapiti = this.auditRuleObject.rule.flgRecapito == "1" ? true : false;
    }


  }

  async validaForms(save: boolean) {
    let validationInfoBase = await this.infoBaseComponent.performValidationInfoBase();
    if (!validationInfoBase) {
      this.goToPhase(0);
      return;
    }

    /* let validationCondition = (maxIndexToPerformValidation >= 1 && this.conditionComponent) ? await this.conditionComponent.performValidationPlanning() : true;
     if (!validationCondition) {
       this.goToPhase(1);
       return;
     }*/
    /*
     questo controllo è stato rimosso perchè non è necessario , il salvataggio viene effettuato nel componente che si occupa dei dettagli regole
     let validationAction = (maxIndexToPerformValidation >= 2 && this.actionComponent) ? await this.actionComponent.performValidationAction() : true;
     if (!validationAction) {
       //this.goToPhase(2);
       return;
     }*/

    //se tutto è giusto procedi al salvataggio
    this.saveAuditRuleInstanceObject(save);
  }

  saveAuditRuleInstanceObject(save: boolean) {
    if (!this.auditRuleObject) {
      //casistica in cui torno indietro prima di salvare regola e/o dettagli
      this.auditRuleObject = new AuditRuleObject(); //TODO MODIFICARE IN CASO EDIT
    }
    //valorizzo l'oggettone
    let maxIndexToPerformValidation = this.currentPhaseIndex

    //testata comune a tutte le tipologie regole
    this.auditRuleObject.rule.auditRulesTypeId = this.infoBaseComponent.selectedRule;
    this.auditRuleObject.rule.description = this.infoBaseComponent.desc_rule.nativeElement.value;
    this.auditRuleObject.rule.code = this.infoBaseComponent.rule_code.nativeElement.value;
    this.auditRuleObject.rule.dtDateEnd = this.getDateStringDBFromDate(this.dateRangeForm.controls.date_end.value);
    this.auditRuleObject.rule.dtDateStart = this.getDateStringDBFromDate(this.dateRangeForm.controls.date_start.value);
    this.auditRuleObject.rule.eventAuditTable = this.infoBaseComponent.sorg_event.nativeElement.value;
    if (this.infoBaseComponent) {

      if (this.infoBaseComponent.cluster) {
        this.auditRuleObject.rule.cluster = this.infoBaseComponent.cluster.fieldModel.label;
        this.auditRuleObject.rule.clusterHeadId = this.infoBaseComponent.cluster.fieldModel.value;
      }
      if (this.infoBaseComponent.acm) {

        if (this.infoBaseComponent.acm_active_range.fieldModel) {
          this.auditRuleObject.rule.flgRangeActive = '1';
          this.auditRuleObject.rule.minRangeValue = this.infoBaseComponent.acm_min.fieldModel;
          this.auditRuleObject.rule.maxRangeValue = this.infoBaseComponent.acm_max.fieldModel;
          this.auditRuleObject.rule.accumulatore = this.infoBaseComponent.acm.fieldModel.label;
          this.auditRuleObject.rule.acmId = this.infoBaseComponent.acm.fieldModel.value;
        } else if (this.infoBaseComponent.acm_active_range.fieldModel == null) {
          //KS-7447 "fix" per gestire le sfide senza aggiungere nuovi campi
          this.auditRuleObject.rule.flgRangeActive = null;
          this.auditRuleObject.rule.minRangeValue = this.infoBaseComponent.fieldModel.rule_challenge ? this.infoBaseComponent.fieldModel.rule_challenge.value : null;
          this.auditRuleObject.rule.maxRangeValue = this.infoBaseComponent.fieldModel.rule_challenge_detail ? this.infoBaseComponent.fieldModel.rule_challenge_detail.value : null;
        } else {
          this.auditRuleObject.rule.flgRangeActive = '0';
          this.auditRuleObject.rule.accumulatore = this.infoBaseComponent.acm.fieldModel.label;
          this.auditRuleObject.rule.acmId = this.infoBaseComponent.acm.fieldModel.value;
          this.auditRuleObject.rule.minRangeValue = null;
          this.auditRuleObject.rule.maxRangeValue = null;
        }
      }
      //if(this.infoBaseComponent.anag){
      if (this.infoBaseComponent && this.infoBaseComponent.show.anag) {
        this.auditRuleObject.rule.anagrafica = true;
        this.auditRuleObject.rule.flgBlacklist = this.infoBaseComponent.cinfo_blacklist.fieldModel ? "1" : "0";
        this.auditRuleObject.rule.flgNewsletter = this.infoBaseComponent.cinfo_newsletter.fieldModel ? "1" : "0";
        this.auditRuleObject.rule.flgNominativo = this.infoBaseComponent.cinfo_nominativo.fieldModel ? "1" : "0";
        this.auditRuleObject.rule.flgPrivacy = this.infoBaseComponent.cinfo_privacy.fieldModel ? "1" : "0";
        this.auditRuleObject.rule.flgRecapito = this.infoBaseComponent.cinfo_recapiti.fieldModel ? "1" : "0";
      }


    }

    //questo fallback serve a correggere l'id di ogni action nel caso in cui salvo in uno dei primi due sheet e sono in update con dettagli già esistenti
    this.auditRuleObject.auditRuleDtl.forEach(element => {
      if (element.audit_action_type_id && element.audit_action_type_id.id) {
        let app: any = element.audit_action_type_id.id;
        element.audit_action_type_id = app;
      }
    })

    
    if (this.auditRuleObject.auditRuleCondition && this.auditRuleObject.auditRuleCondition.length > 0) {
      this.auditRuleObject.rule.conditionBooleanOperator = this.conditionComponent.selectedOperatorBooleanCondition;
    } else if(this.infoBaseComponent.fieldModel.rule_challenge){
      //nel caso della challenge il campo non deve cambiare nella rule
      console.debug("condizione Operatore booleano - challenge", this.auditRuleObject.rule.conditionBooleanOperator);
    } else {
      this.auditRuleObject.rule.conditionBooleanOperator = null;
    }

    
    this.auditRuleObject.auditRuleCondition.forEach(element => {
      if (element.audit_rules_condition_type_id && element.audit_rules_condition_type_id.id) {
        let app: any = element.audit_rules_condition_type_id.id;
        element.audit_rules_condition_type_id = app;
      }
    })

    if (save) {
      if (this.auditRuleObject && this.auditRuleObject.rule
        && this.auditRuleObject.rule.id && this.auditRuleObject.rule.id > 0)
        this.performUpdateAuditRuleInstance();
      else
        this.performSaveAuditRuleInstance(maxIndexToPerformValidation);
    } else
      this.goToPhase(this.phaseClick ? this.phaseClick.index : this.currentPhaseIndex + 1);

  }

  processPhases(firstUndonePhaseIndex: number, isCurrent: boolean) {
    // In modalità EDIT, tutte le fasi sono considerate completate
    const isEditMode = this.ruleId && this.ruleId > 0;

    for (let phase of this.auditPhases) {
      if (isEditMode) {
        // In EDIT mode, marca tutte le fasi come completate tranne quella corrente
        phase.done = phase.index !== firstUndonePhaseIndex;
        phase.current = phase.index === firstUndonePhaseIndex && isCurrent;
        phase.firstUndone = false;
      } else {
        // In CREATE mode, usa la logica originale
        if (phase.index < firstUndonePhaseIndex) {
          phase.done = true;
          phase.current = false;
          phase.firstUndone = false;
        } else if (phase.index == firstUndonePhaseIndex) {
          phase.done = false;
          phase.current = isCurrent ? isCurrent : false;
          phase.firstUndone = true;
        } else {
          phase.done = false;
          phase.current = false;
          phase.firstUndone = false;
        }
      }
    }
  }

  performSaveAuditRuleInstance(maxIndexToPerformValidation: number) {
    var self = this;
    this.rulesService.saveAuditRuleGlobalObject(this.auditRuleObject).subscribe(res => {

      if (res) {

        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });

        if (maxIndexToPerformValidation == this.getFirstPhaseUndoneIndex()) {
          //  self.processPhases(self.currentPhaseIndex + 1, true);
        }
        this.router.navigate(['/rules-list'], {
          queryParams: { ruleId: res.rule.id }
        });
      } else {
        self.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericActionError')
        });
      }
    });
  }

  performUpdateAuditRuleInstance() {
    var self = this;
    this.rulesService.updateAuditRuleGlobalObject(this.auditRuleObject).subscribe(res => {

      if (res) {
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });


        this.router.navigate(['/rules-list'], {
          queryParams: { ruleId: this.ruleId }
        });
      } else {
        self.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericActionError')
        });
      }
    });
  }

  onClickFwdBtn() {
    //validazione prima form e vai alla fase successiva
    this.phaseClick = null; // Resetta il click sulla fase per forzare la navigazione sequenziale
    this.validaForms(false);
  }

  getFirstPhaseUndoneIndex(): number {
    let index = null;
    for (let i = 0; i < this.auditPhases.length; i++) {
      if (this.auditPhases[i].firstUndone == true) {
        index = i;
        return index;
      }
      ;
    }
    return index;
  }

  resetForm() {
    this.infoBaseComponent.fieldModel.acm = null;
    this.infoBaseComponent.fieldModel.acm_max = null;
    this.infoBaseComponent.fieldModel.acm_active_range = null;
    this.infoBaseComponent.fieldModel.acm_min = null;
    this.infoBaseComponent.fieldModel.rule_challenge = null;
    this.infoBaseComponent.fieldModel.rule_challenge_detail = null;
    this.infoBaseComponent.fieldModel.anag = null;
    this.infoBaseComponent.fieldModel.cinfo_blacklist = null;
    this.infoBaseComponent.fieldModel.cinfo_newsletter = null;
    this.infoBaseComponent.fieldModel.cinfo_nominativo = null;
    this.infoBaseComponent.fieldModel.cinfo_privacy = null;
    this.infoBaseComponent.fieldModel.cinfo_recapiti = null;
    this.infoBaseComponent.fieldModel.cluster = null;
    this.infoBaseComponent.desc_rule.nativeElement.value = null;
    this.infoBaseComponent.rule_code.nativeElement.value = null;
    this.dateRangeForm = this.fb.group({
      date_end: [null, Validators.required],
      date_start: [null, Validators.required]
    });

    this.auditRuleObject = null;
  }

  onFormSchemaChanged(newGlobalFormSchema: JsonSchema) {
    if (!newGlobalFormSchema) { return; }
    this.globalFormsSchema = newGlobalFormSchema;
    var self = this;
    if (this.uiModes.infoBase == this.rulesService.ui_modes.CREATE)
      this.resetForm();


    if (this.infoBaseComponent) {

      this.infoBaseComponent.ready.form = false;
      this.infoBaseComponent.formSchema = newGlobalFormSchema.properties.infoBase;
      setTimeout(function () {
        self.infoBaseComponent.ready.form = true;
        setTimeout(function () {
          self.infoBaseComponent.ngOnInit();
        }, 100);
      }, 100);
    }


    if (this.conditionComponent) {
      this.conditionComponent.show.form = false;
      this.conditionComponent.formSchema = newGlobalFormSchema.properties.condition;
      setTimeout(function () {
        self.conditionComponent.show.form = true;
        setTimeout(function () {
          self.conditionComponent.ngOnInit();
        }, 500);
      }, 500);
    }

    if (this.actionComponent) {
      this.actionComponent.show.form = false;
      this.actionComponent.formSchema = newGlobalFormSchema.properties.action;
      setTimeout(function () {
        self.actionComponent.show.form = true;
        setTimeout(function () {
          self.actionComponent.ngOnInit();
        }, 100);
      }, 100);

    }

  }
  getDateStringDBFromDate(date: Moment): string | null {
    // let formattedStartDate = moment(date).format('DD-MM-YYYY');
    const dataConvertita = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    return dataConvertita;
  }

  getDateFromStringToSTringCalendar(date: string): string | null {
    let formattedStartDate = moment(date).format('DD/MM/YYYY');
    return formattedStartDate;
  }

  initForm() {
    this.dateRangeForm = this.fb.group({
      date_end: [null, Validators.required],
      date_start: [null, Validators.required]
    });
  }

  onConditionObjectChanged(auditRuleObject: AuditRuleObject) {
    this.auditRuleObject = auditRuleObject;
  }

  private setSelectedChallengeOption() {
    const selectedChallengeOpt = this.infoBaseComponent.filteredChallengeList.find(opt => opt.value === this.auditRuleObject.rule.minRangeValue);
    this.infoBaseComponent.fieldModel.rule_challenge = selectedChallengeOpt || null;
  }

  private setSelectedDetailOption() {
    const selectedChallengeOpt = this.infoBaseComponent.fieldModel.rule_challenge;
    if (selectedChallengeOpt) {
      this.challengeService.getCampaignChallengeDetails(selectedChallengeOpt.value).subscribe(resp => {
        this.infoBaseComponent.challengeDetailList = (resp || []).map(cd => ({
          value: cd.id,
          label: cd.description + ' | ' + cd.longDescr
        }));

        const selectedDetailOpt = this.infoBaseComponent.challengeDetailList
          .find(opt => opt.value === this.auditRuleObject.rule.maxRangeValue);

        this.infoBaseComponent.fieldModel.rule_challenge_detail = selectedDetailOpt || null;
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/add-rule.component.ts